import React from 'react'

export function SoporteComentarios() {
  return (
    <div>SoporteComentarios</div>
  )
}
